import { render, staticRenderFns } from "./PortfolioListUserLayout.vue?vue&type=template&id=08c2c58e&scoped=true"
import script from "./PortfolioListUserLayout.vue?vue&type=script&lang=js"
export * from "./PortfolioListUserLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2c58e",
  null
  
)

export default component.exports